import { useFormContext } from 'react-hook-form';

import type { QConfigStructureFormInput } from './qconfig-structure-form-schema';

export const useQConfigStructureFormContext = useFormContext<QConfigStructureFormInput>;
